import { validateString } from "../validateString";

export const validatePasswordBasic = (value?: string | null) => {
  if (validateString(value)) {
    return "Please enter your password";
  }

  return undefined;
};

export function validatePassword(password?: string | null) {
  if (!password) {
    return "Please enter a password";
  }

  if (password.length < 8) {
    return "Your password must be 8 characters long";
  }

  if (!/[a-z]/.test(password)) {
    return "Must contain at least 1 lower case letter";
  }

  if (!/[A-Z]/.test(password)) {
    return "Must contain at least 1 upper case letter";
  }

  if (!/[\d]/.test(password)) {
    return "Must contain at least 1 number";
  }

  if (!/^[\S]+.*[\S]+$/.test(password)) {
    return "Your password can't start or end with a space";
  }

  return undefined;
}
